import { useState } from "react";
import { Crown, Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function PinGate() {
  const { pinLogin } = useAuth();
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await pinLogin(pin);
      toast.success("Accès autorisé");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Code PIN incorrect");
      setPin("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#f8fafc]" data-testid="pin-gate">
      <div className="w-full max-w-xs animate-in-up text-center">
        <div className="h-14 w-14 rounded-2xl bg-[#0ea5e9] flex items-center justify-center mx-auto mb-5">
          <Crown className="h-7 w-7 text-white" />
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Club Privilège Diabliss</h1>
        <p className="text-slate-500 text-sm mb-8 flex items-center justify-center gap-1.5">
          <Lock className="h-3.5 w-3.5" /> Accès protégé par code PIN
        </p>
        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="pin-input"
            type="password"
            inputMode="numeric"
            autoFocus
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="••••"
            className="w-full text-center tracking-[0.5em] text-2xl px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-sky-500 transition-colors duration-200"
          />
          <button
            data-testid="pin-submit"
            type="submit"
            disabled={loading || pin.length < 4}
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-[#0ea5e9] hover:bg-[#0284c7] text-white font-semibold transition-colors duration-200 disabled:opacity-50"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Déverrouiller
          </button>
        </form>
      </div>
    </div>
  );
}
